import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 26px;
  background-color: #F9FBFC;
  border-bottom: 1px solid #e8e8e8;
  position: relative;
`;

export const TextsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const BackButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid #CACACA;
  color: #031795;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #e7e7e7;
    color: #0023ff;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const SubTitle = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  margin-left: 6px;
  color: #000;
`;

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 42px;
  line-height: 32px;
  margin-top: 6px;
  margin-bottom: 0;
  font-weight: 500;
  color: #000;
`;

export const SmallerPolygonVector = styled.img`
  position: absolute;
  top: 28px;
  right: 60%;
`;

export const BiggerPolygonVector = styled.img`
  position: absolute;
  top: 8px;
  right: 10%;
  transform: skewY(-4deg);

  width: 280px;
`;

export const FilterInputs = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  background: #fff;
  z-index: 10;
  padding: 8px;
  border: 1px solid #CACACA;
  border-radius: 4px;
`;

export const AngloAmericanLogo = styled.img`
  width: 178px;
  height: 70px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
`;

export const HorizontalContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;  
  margin-bottom: 32px;
`;
